module.exports = __webpack_public_path__ + "static/media/billing_icon.db65f21c.png";